import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showError, showSuccess } from '../../services/alert';

const UsuarioForm = () => {
  const [usuario, setUsuario] = useState({
    nome: '',
    email: '',
    senha: '',
    perfil: '' // 👈 novo campo
  });
  const [senha, setSenha] = useState({ novaSenha: '', confirmacaoSenha: '' });

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      api.get(`/usuario/${id}`)
        .then(response => setUsuario({
          nome: response.data.nome || '',
          email: response.data.email || '',
          senha: '',
          perfil: response.data.perfil || ''
        }))
        .catch(error => console.error('Erro ao buscar usuário:', error));
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUsuario(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        if (senha.novaSenha || senha.confirmacaoSenha) {
          if (senha.novaSenha.length < 8) {
            showError('A nova senha deve ter pelo menos 8 caracteres.');
            return;
          }
          if (senha.novaSenha !== senha.confirmacaoSenha) {
            showError('A confirmação da nova senha não confere.');
            return;
          }
        }
        await api.put(`/usuario/${id}`, { ...usuario, senhaHash: '' });
        if (senha.novaSenha) await api.put(`/usuario/${id}/senha`, senha);
      } else {
        await api.post('/usuario', usuario);
      }
      showSuccess(id ? 'Usuário atualizado com sucesso.' : 'Usuário criado com sucesso.');
      navigate('/usuarios');
    } catch (error) {
      showError(error.response?.data?.message || 'Não foi possível salvar o usuário.');
    }
  };

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <h5 className="mb-0">{id ? 'Editar Usuário' : 'Cadastrar Novo Usuário'}</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit} className="row g-4">
            <fieldset className="border p-3 rounded-3">
              <legend className="float-none w-auto px-3 text-success fw-semibold">
                Informações do Usuário
              </legend>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Nome</label>
                <input
                  type="text"
                  name="nome"
                  value={usuario.nome}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Email</label>
                <input
                  type="email"
                  name="email"
                  value={usuario.email}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  required
                />
              </div>

              {!id && (
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Senha</label>
                  <input
                    type="password"
                    name="senha"
                    value={usuario.senha}
                    onChange={handleChange}
                    className="form-control rounded-3"
                    required
                  />
                </div>
              )}

              {id && (
                <div className="row g-3 mt-1">
                  <div className="col-12">
                    <hr />
                    <h6 className="text-success fw-semibold mb-0">
                      <i className="bi bi-shield-lock me-2" />Alterar senha
                    </h6>
                    <small className="text-muted">Deixe os campos vazios para manter a senha atual.</small>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Nova senha</label>
                    <input type="password" className="form-control rounded-3" value={senha.novaSenha}
                      onChange={(e) => setSenha((prev) => ({ ...prev, novaSenha: e.target.value }))}
                      minLength="8" autoComplete="new-password" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Confirmar nova senha</label>
                    <input type="password" className="form-control rounded-3" value={senha.confirmacaoSenha}
                      onChange={(e) => setSenha((prev) => ({ ...prev, confirmacaoSenha: e.target.value }))}
                      minLength="8" autoComplete="new-password" />
                  </div>
                </div>
              )}

              <div className="col-md-6">
                <label className="form-label fw-semibold">Grupo de Acesso</label>
                <select
                  name="perfil"
                  value={usuario.perfil}
                  onChange={handleChange}
                  className="form-select rounded-3"
                  required
                >
                  <option value="">Selecione...</option>
                  <option value="Admin">Administrador</option>
                  <option value="Financeiro">Financeiro</option>
                  <option value="Agricultor">Agricultor</option>
                  <option value="Operacional">Operacional</option>
                </select>
              </div>

              <div className="col-12 d-flex justify-content-end mt-3">
                <button type="submit" className="btn btn-success me-2 d-flex align-items-center gap-1">
                  <i className="bi bi-save"></i>
                  <span>Salvar</span>
                </button>
                <button
                  type="button"
                  className="btn btn-secondary d-flex align-items-center gap-1"
                  onClick={() => navigate('/usuarios')}
                >
                  <i className="bi bi-x-circle"></i>
                  <span>Cancelar</span>
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UsuarioForm;
